<section class="section-title">
    <div class="section-title-image">
        <img class="user-image" src="assets/img/user.png" />
    </div>

    <div class="section-title-text">
        <h1 *ngIf=!userCreated i18n="@@addOperator_title">Aggiungi operatore</h1>

        <h1 *ngIf=userCreated i18n="@@addOperator_title_alt">Modifica operatore</h1>
    </div>
</section>

<section>
    <form [formGroup]="addUserForm">
        <table class="simple-table user-add-table">
            <tr>
                <td width="300px" class="text-dark" i18n="@@addOperator_name">Nome</td>
                <td><input id="name-input" formControlName="name" [(ngModel)]="username" /></td>
            </tr>

            <tr>
                <td width="300px" class="text-dark" i18n="@@addOperator_description">Descrizione</td>
                <td><input id="description-input" formControlName="description" [(ngModel)]="description" /></td>
            </tr>

            <tr>
                <td width="300px" class="text-dark" i18n="@@addOperator_email">Email</td>
                <td><input id="userEmail" formControlName="userEmail" [(ngModel)]="userEmail" /></td>
            </tr>

            <br>
            <br>
            <br>
            <br>

            <tr class="radioButtonTr">
                <td width="300px" class="text-dark" i18n="@@addOperator_see_devices">Accesso lista dispositivi :</td>
                <td class="radioButton">
                    <ng-container i18n="@@Enable">Abilita</ng-container>
                    <div id="radioButtonDiv">
                        <label class="radioButtonLabel"> <input type="radio" formControlName="enableSeeDevices"
                                [(ngModel)]="enableSeeDevicesBool" name="enableSeeDevices" value="true">
                        </label>
                    </div>
                    <ng-container i18n="@@Disable">Disabilita</ng-container>
                    <div id="radioButtonDiv">
                        <label class="radioButtonLabel">
                            <input type="radio" formControlName="enableSeeDevices" [(ngModel)]="enableSeeDevicesBool"
                                name="enableSeeDevices" value="false" />
                        </label>
                    </div>
                </td>
            </tr>

            <tr class="radioButtonTr">
                <td width="300px" class="text-dark" i18n="@@addOperator_action_device">Azionamento dispositivi :</td>
                <td class="radioButton">
                    <ng-container i18n="@@Enable">Abilita</ng-container>
                    <div id="radioButtonDiv">
                        <label class="radioButtonLabel"> <input type="radio" formControlName="enableActionateDevices"
                                [(ngModel)]="enableActionateDevicesBool" name="enableActionateDevices" value="true">
                        </label>
                    </div>
                    <ng-container i18n="@@Disable">Disabilita</ng-container>
                    <div id="radioButtonDiv">
                        <label class="radioButtonLabel">
                            <input type="radio" formControlName="enableActionateDevices"
                                [(ngModel)]="enableActionateDevicesBool" name="enableActionateDevices" value="false" />
                        </label>
                    </div>
                </td>
            </tr>

            <tr class="radioButtonTr">
                <td width="300px" class="text-dark" i18n="@@addOperator_see_access_log">Visione registro accessi :</td>
                <td class="radioButton">
                    <ng-container i18n="@@Enable">Abilita</ng-container>
                    <div id="radioButtonDiv">
                        <label class="radioButtonLabel"> <input type="radio" formControlName="enableSeeAccessLog"
                                [(ngModel)]="enableSeeAccessLogBool" name="enableSeeAccessLog" value="true">
                        </label>
                    </div>
                    <ng-container i18n="@@Disable">Disabilita</ng-container>
                    <div id="radioButtonDiv">
                        <label class="radioButtonLabel">
                            <input type="radio" formControlName="enableSeeAccessLog"
                                [(ngModel)]="enableSeeAccessLogBool" name="enableSeeAccessLog" value="false" />
                        </label>
                    </div>
                </td>
            </tr>

            <br>
            <br>

            <tr class="radioButtonTr">
                <td width="300px" class="text-dark" i18n="@@addOperator_user_edit">Creazione e modifica utenti :</td>
                <td class="radioButton">
                    <ng-container i18n="@@Enable">Abilita</ng-container>
                    <div id="radioButtonDiv">
                        <label class="radioButtonLabel"> <input type="radio" formControlName="enableUserEdit"
                                [(ngModel)]="enableUserEditBool" name="enableUserEdit" value="true">
                        </label>
                    </div>
                    <ng-container i18n="@@Disable">Disabilita</ng-container>
                    <div id="radioButtonDiv">
                        <label class="radioButtonLabel">
                            <input type="radio" formControlName="enableUserEdit" [(ngModel)]="enableUserEditBool"
                                name="enableUserEdit" value="false" />
                        </label>
                    </div>
                </td>
            </tr>

            <tr class="radioButtonTr">
                <td width="300px" class="text-dark" i18n="@@addOperator_group_edit">Creazione e modifica gruppi :</td>
                <td class="radioButton">
                    <ng-container i18n="@@Enable">Abilita</ng-container>
                    <div id="radioButtonDiv">
                        <label class="radioButtonLabel"> <input type="radio" formControlName="enableGroupEdit"
                                [(ngModel)]="enableGroupEditBool" name="enableGroupEdit" value="true">
                        </label>
                    </div>
                    <ng-container i18n="@@Disable">Disabilita</ng-container>
                    <div id="radioButtonDiv">
                        <label class="radioButtonLabel">
                            <input type="radio" formControlName="enableGroupEdit" [(ngModel)]="enableGroupEditBool"
                                name="enableGroupEdit" value="false" />
                        </label>
                    </div>
                </td>
            </tr>

            <tr class="radioButtonTr">
                <td width="300px" class="text-dark" i18n="@@addOperator_edit_automations">Creazione e modifica
                    automatismi :</td>
                <td class="radioButton">
                    <ng-container i18n="@@Enable">Abilita</ng-container>
                    <div id="radioButtonDiv">
                        <label class="radioButtonLabel"> <input type="radio" formControlName="enableEditAutomations"
                                [(ngModel)]="enableEditAutomationsBool" name="enableEditAutomations" value="true">
                        </label>
                    </div>
                    <ng-container i18n="@@Disable">Disabilita</ng-container>
                    <div id="radioButtonDiv">
                        <label class="radioButtonLabel">
                            <input type="radio" formControlName="enableEditAutomations"
                                [(ngModel)]="enableEditAutomationsBool" name="enableEditAutomations" value="false" />
                        </label>
                    </div>
                </td>
            </tr>

            <tr class="radioButtonTr">
                <td width="300px" class="text-dark" i18n="@@addOperator_see_operations_log">Visione registro operazioni
                    :</td>
                <td class="radioButton">
                    <ng-container i18n="@@Enable">Abilita</ng-container>
                    <div id="radioButtonDiv">
                        <label class="radioButtonLabel"> <input type="radio" formControlName="enableSeeOperationsLog"
                                [(ngModel)]="enableSeeOperationsLogBool" name="enableSeeOperationsLog" value="true">
                        </label>
                    </div>
                    <ng-container i18n="@@Disable">Disabilita</ng-container>
                    <div id="radioButtonDiv">
                        <label class="radioButtonLabel">
                            <input type="radio" formControlName="enableSeeOperationsLog"
                                [(ngModel)]="enableSeeOperationsLogBool" name="enableSeeOperationsLog" value="false" />
                        </label>
                    </div>
                </td>
            </tr>


        </table>

        <br>
        <br>

        <a (click)="createOperator()" class="button user-add-button">
            <ng-container i18n="@@addOperator_create_user">Crea operatore</ng-container>
            <span>
                <fa-icon icon="save"></fa-icon>
            </span>
        </a>
        <p class="text-small text-error margin-top-10 display-inline" *ngIf="usernameError && userCreated"
            i18n="@@addOperator_username_error">
            Inserire il nome operatore
        </p>
        <p class="text-small text-error margin-top-10 display-inline" *ngIf="emailError && userCreated"
            i18n="@@addOperator_email_error">
            Indirizzo email non valido
        </p>
        <p class="text-small text-error margin-top-10 display-inline" *ngIf="missingCriteriaError && userCreated"
            i18n="@@addOperator_missing_criteria_error">
            Inserire tutti i permessi
        </p>
    </form>
</section>


<app-loading-screen #adduserloader [loading]="false" [showtext]="false"></app-loading-screen>